import React from "react"
import { History } from "history"
import { ThrowError } from "../../../../error/error"
import { NotificationActionDispatcher } from "../../../../libs/notifications"
import { AuthFrame } from "../../../../components/templates/auth/components/auth-frame"
import { Form } from "../../../../components/templates/auth/components/auth-sns-connect-form/form"
import { ISessionActionCreator } from "../../../../actions/sessionActionCreator"
import { IFormField } from "../../../../components/templates/auth/components/auth-sns-connect-form/form-meta"
import { RouteComponentProps } from "react-router"
import { AuthWrapper } from "../../signin"

const AuthMethod = "SNS連携登録"

export enum Platform {
  Facebook = "facebook",
  Twitter = "twitter",
}

type IProps = {
  history: History
  location: Location
  sessionActions: ISessionActionCreator
} & RouteComponentProps<{
  key: string
}>

interface IState {
  formData: {
    email?: string
    name?: string
    screenName?: string
  }
  userId: string
  accessToken: string
  tokenSecret?: string
}

export abstract class SNSCallbackComponent extends React.Component<
  IProps,
  IState
> {
  protected platform: Platform

  constructor(props: IProps) {
    super(props)
    this.state = {
      formData: {},
      accessToken: "",
      userId: "",
    }
    this.submit = this.submit.bind(this)
    this.callback = this.callback.bind(this)
  }

  // TODO エラーページのレンダリング
  public componentDidMount() {
    const qsMap: { [key: string]: string } = {}
    this.props.location.search
      .replace("?", "")
      .split("&")
      .forEach(x => {
        const components = x.split("=")
        qsMap[components[0]] = components[1]
      })
    if (qsMap.p) {
      const initialFormData = JSON.parse(
        new Buffer(qsMap.p, "base64").toString(),
      )
      this.setState({
        formData: {
          email: initialFormData.email,
          name: initialFormData.name,
          screenName: initialFormData.screenName,
        },
        accessToken: initialFormData.accessToken,
        tokenSecret: initialFormData.tokenSecret,
        userId: initialFormData.userId.toString(),
      })
    } else {
      // TODO エラーページに遷移
      console.warn("エラーページをレンダリング")
      return
    }
  }

  public render() {
    return (
      <AuthWrapper>
        <AuthFrame title={AuthMethod}>
          <Form onSubmit={this.submit} initialValues={this.state.formData} />
        </AuthFrame>
      </AuthWrapper>
    )
  }

  private callback(success: boolean, e?: any) {
    if (success) {
      NotificationActionDispatcher.SuccessNotification("登録が完了しました")
      this.props.history.push("/")
    } else {
      ThrowError(e)
    }
  }

  private submit(values: IFormField) {
    switch (this.platform) {
      case Platform.Twitter:
        this.props.sessionActions.registerFromTwitter(
          {
            email: values.email,
            name: values.name,
            screenName: values.screenName,
            accessToken: this.state.accessToken,
            tokenSecret: this.state.tokenSecret,
            userId: this.state.userId,
          },
          this.callback,
        )
        break
      case Platform.Facebook:
        this.props.sessionActions.registerFromFacebook(
          {
            email: values.email!,
            name: values.name!,
            screenName: values.screenName!,
            accessToken: this.state.accessToken,
            userId: this.state.userId,
          },
          this.callback,
        )
        break
    }
  }
}
